'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotDonutIcon = function PlotDonutIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M26 5.625l-3.875 4.5A8.43 8.43 0 0 1 24.5 16a8.93 8.93 0 0 1-.188 1.813L30 19.501c.25-1.125.375-2.313.375-3.5A14.49 14.49 0 0 0 26 5.626zM12 8.5a8.622 8.622 0 0 1 4-1c1.75 0 3.313.5 4.688 1.438l3.813-4.563c-2.375-1.75-5.313-2.75-8.5-2.75-2.625 0-5.063.688-7.188 1.875zm11.625 11.125c-1.25 2.625-3.813 4.563-7 4.813v5.938a14.51 14.51 0 0 0 12.688-9.063zm-8.875 4.813c-4.188-.563-7.313-4.125-7.313-8.438 0-2.563 1.188-4.875 2.938-6.438l-3.188-5C3.749 7.25 1.499 11.375 1.499 16c0 7.563 5.875 13.75 13.25 14.375z' })
    );
};

exports.default = PlotDonutIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotDonutIcon.js
// module id = 658
// module chunks = 0